import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../TypeList/type.css';
import { deleteObject, getStorage,ref as storageRef } from 'firebase/storage';
import{app} from '../../firebase'
import { useNavigate } from 'react-router-dom';

const TypeList = () => {
    const [type, setType] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getType();
    }, []);

    const getType = () => {
        axios.get('https://pkrealestateapi.onrender.com/type')
            .then(res => {
                console.log(res.data.type);
                setType(res.data.type);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const deleteType = (typeData) => {
        
        if (window.confirm("Are you sure you want to delete this item?")) {

          const storage = getStorage(app);
          const myRef = storageRef(storage, `${typeData.imageUrl}`);
          deleteObject(myRef)
          .then(result=>{
            axios.delete(`https://pkrealestateapi.onrender.com/type/` + typeData._id, {
              headers: {
                  'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImlzaGFhbmthbGFudHJlMTIzQGdtYWlsLmNvbSIsImZ1bGxOYW1lIjoiSXNoYWFuIEthbGFudHJlIiwidXNlclR5cGUiOiJhZG1pbiIsImlhdCI6MTcyOTE5OTAyOCwiZXhwIjoxNzYwNzM1MDI4fQ.SKAj0ZOasAo0NNSvzTZvNCyPuzWzeS-tXZuUt5cEEz8` 
              }
          })
          .then(res => {
              console.log(res);
              getType(); 
          })
          .catch(err => {
              console.log(err);
          });
          }) 
          .catch(error=>{
            console.log(error);   
          })
            
        }
    };

    return (
        <div className="container">
            {type.map(data => (
                <div className='typecard' key={data._id}>
                    <p>{data.name}</p>
                    <img className='type-img' src={data.imageUrl} alt={data.name} />
                    <button onClick={()=>{navigate('/admin/dashboard/edit-type',{state:{myData:data}})}} className="edit-btn">Edit</button>
                    <button onClick={() => deleteType(data)} className="delete-btn">Delete</button>
                </div>
            ))}
        </div>
    );
};

export default TypeList;